/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'cross_product_search_dialog.atlas.tab_label': 'Atlas',
  'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
  'cross_product_search_dialog.confluence.tab_label': 'Confluence',
  'cross_product_search_dialog.google_drive.tab_label': 'Drive',
  'cross_product_search_dialog.google_drive.unauthenticated_prompt':
    'Atlassian에서 나가지 않고도 모든 Google 스프레드시트, 문서, 프레젠테이션 등에서 작업할 수 있습니다. 이 액세스 권한은 사용자에게만 있습니다.',
  'cross_product_search_dialog.jira.tab_label': 'Jira',
  'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
  'cross_product_search_dialog.recently_viewed_title': '최근에 본 {sectionTitle}',
  'cross_product_search_dialog.townsquare_globex_tab_label': '홈',
  'cross_product_search_dialog.townsquare_recent_goals': '최근 목표',
  'cross_product_search_dialog.townsquare_recent_help_links': '최근 도움말 링크',
  'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': '최근 배운 점, 위험 및 결정',
  'cross_product_search_dialog.townsquare_recent_projects': '최근 프로젝트',
  'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
  'cross_product_search_dialog.trello.tab_label': 'Trello',
  'cross_product_search_dialog.view_all_results_link': '모든 {sectionTitle} 보기',
  'extensible_search_dialog.advanced_search': '고급 검색',
  'extensible_search_dialog.advanced_search_cross_product': '제품 전체에서 검색',
  'extensible_search_dialog.connect': '연결',
  'extensible_search_dialog.connect_to': '연결 대상',
  'global_search.jira.advanced_search_boards': '보드',
  'global_search.jira.advanced_search_filters': '필터',
  'global_search.jira.advanced_search_issues': '이슈',
  'global_search.jira.advanced_search_issues-issue-term-refresh': '업무 항목',
  'global_search.jira.advanced_search_label': '모든 항목으로 이동:',
  'global_search.jira.advanced_search_people': '사용자',
  'global_search.jira.advanced_search_plans': '계획',
  'global_search.jira.advanced_search_projects': '프로젝트',
  'global_search.jira.search_placeholder': 'Jira 검색',
  'global_search.jira.search_placeholder_experiment_jsw_enabled': '이슈, 보드, 프로젝트 및 필터 검색',
  'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh':
    '업무 항목, 보드, 프로젝트 및 필터 검색',
  'product_s earch_dialog.confluence.assignee_filters_find_more': '담당자 찾기',
  'product_search_dialog.atlas.search_input_expanded_placeholder': 'Atlas 검색',
  'product_search_dialog.autocorrection.label': '무엇을 의미했습니까?',
  'product_search_dialog.bitbucket.bitbucket_advanced_search': '{source}에서 코드 검색',
  'product_search_dialog.bitbucket.bitbucket_recent_repositories': '최근에 업데이트한 리포지토리',
  'product_search_dialog.bitbucket.bitbucket_repositories_section_title': '리포지토리',
  'product_search_dialog.bitbucket.expanded.input-placeholder': 'Bitbucket 검색',
  'product_search_dialog.bitbucket.repository_heading': '리포지토리',
  'product_search_dialog.common.site_filters': '사이트로 필터링',
  'product_search_dialog.compass.component_type.application': '애플리케이션',
  'product_search_dialog.compass.component_type.capability': '기능',
  'product_search_dialog.compass.component_type.cloud_resource': '클라우드 리소스',
  'product_search_dialog.compass.component_type.data_pipeline': '데이터 파이프라인',
  'product_search_dialog.compass.component_type.library': '라이브러리',
  'product_search_dialog.compass.component_type.machine_learning_model': '머신러닝 모델',
  'product_search_dialog.compass.component_type.other': '기타',
  'product_search_dialog.compass.component_type.service': '서비스',
  'product_search_dialog.compass.component_type.ui_element': 'UI 요소',
  'product_search_dialog.compass.component_type.website': '웹 사이트',
  'product_search_dialog.compass.components_section_heading': '컴포넌트',
  'product_search_dialog.compass.expanded.input-placeholder': 'Compass 검색',
  'product_search_dialog.compass.people_section_heading': '사용자',
  'product_search_dialog.compass.recently_viewed_components': '최근에 본 컴포넌트',
  'product_search_dialog.compass.recently_viewed_teams': '최근에 본 팀',
  'product_search_dialog.compass.tab_label': 'Compass',
  'product_search_dialog.compass.teams_section_heading': '팀',
  'product_search_dialog.compass.upsell_modal_cta_text': 'Compass 무료로 받기',
  'product_search_dialog.compass.upsell_modal_description':
    '소프트웨어 아키텍처를 한곳에 카탈로그로 정리하세요. 작업하는 팀이 컨텍스트 전환을 줄이고 필요한 것을 더 빠르게 찾고 생산성을 높일 수 있습니다. 개발자 경험에 긍정적인 영향을 줄 것입니다.',
  'product_search_dialog.compass.upsell_modal_description.bitbucket':
    '중앙 집중식 소프트웨어 카탈로그에 연결하여 리포지토리의 소유자, 종속성 및 도움말 리소스를 확인하세요.',
  'product_search_dialog.compass.upsell_modal_heading':
    '개발자가 시간을 관리할 수 있도록 소프트웨어 스프롤을 제어하세요',
  'product_search_dialog.compass.upsell_modal_heading.bitbucket': '코드에 더 많은 컨텍스트 제공',
  'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Compass에 대해 자세히 알아보기',
  'product_search_dialog.compass.upsell_modal_learn_more_link': '자세히 알아보기',
  'product_search_dialog.compass.upsell_tab_title_lozenge': '신규',
  'product_search_dialog.compass.view_all_components_label': '모든 컴포넌트 보기',
  'product_search_dialog.compass.view_all_results_label': '모든 결과 보기',
  'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence 고급 검색',
  'product_search_dialog.confluence.clear_filters': '필터 지우기',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.description':
    '팀이 Confluence에서 공동 작업하고 있습니다. 페이지, 화이트보드 및 데이터베이스로 Jira 프로젝트에 대한 팀 지식을 체계화하고 아이디어를 캡처하고 요구 사항을 공유하세요.',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': '팀에 참여',
  'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': '자세히 알아보기',
  'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': '더 많은 결과',
  'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': '무료 액세스',
  'product_search_dialog.confluence.content_section_heading': '콘텐츠',
  'product_search_dialog.confluence.contributor_filters': '기여자로 필터링',
  'product_search_dialog.confluence.contributor_filters_find_more': '기여자 찾기',
  'product_search_dialog.confluence.date_filter_title': '마지막 업데이트',
  'product_search_dialog.confluence.date_filter_today': '오늘',
  'product_search_dialog.confluence.date_filter_yesterday': '어제',
  'product_search_dialog.confluence.date_filters_any': '모든 시간',
  'product_search_dialog.confluence.date_filters_month': '지난 30일',
  'product_search_dialog.confluence.date_filters_week': '지난 7일',
  'product_search_dialog.confluence.date_filters_year': '지난해',
  'product_search_dialog.confluence.empty_state_body_no_advanced_search':
    '다른 키워드, 더 적은 키워드 또는 더 일반적인 키워드를 사용해 보세요.',
  'product_search_dialog.confluence.empty_state_body_prequery_filters':
    '선택한 필터로는 지난 90일 동안 만들거나 업데이트한 항목을 찾을 수 없습니다.',
  'product_search_dialog.confluence.empty_state_body_title': '검색과 일치하는 결과가 없습니다.',
  'product_search_dialog.confluence.filters_applied': '몇 가지 필터가 적용된 것 같습니다',
  'product_search_dialog.confluence.pages_blogs_attachments_section_heading': '페이지, 블로그 및 첨부 파일',
  'product_search_dialog.confluence.people_section_heading': '사용자',
  'product_search_dialog.confluence.search_input_expanded_placeholder': 'Confluence 검색',
  'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Confluence에서 검색 또는 질문하세요',
  'product_search_dialog.confluence.space_filters': '스페이스로 필터링',
  'product_search_dialog.confluence.space_filters_find_more': '스페이스 찾기',
  'product_search_dialog.confluence.spaces_section_heading': '스페이스',
  'product_search_dialog.confluence.typing_state_header_text': 'Confluence의 콘텐츠 검색',
  'product_search_dialog.empty.no_results_body':
    '다른 용어로 다시 시도하거나, <a>고급 검색</a>으로 상세하게 결과를 검색하세요.',
  'product_search_dialog.empty.no_results_body_with_no_advanced_search': '다른 검색어로 다시 시도하세요.',
  'product_search_dialog.empty.no_results_heading': '검색과 일치하는 결과가 없습니다.',
  'product_search_dialog.empty_prequery.error_heading': '초기 결과를 표시하는 데 문제가 발생했습니다',
  'product_search_dialog.empty_prequery.no_results_heading': '필요한 내용을 검색하세요',
  'product_search_dialog.error.failed_loading_search_body':
    '일시적인 문제일 수 있습니다. 페이지를 새로 고치거나 <emptyLink>다시 시도하세요.</emptyLink>',
  'product_search_dialog.error.failed_loading_search_heading':
    '최근에 조회한 콘텐츠를 로드하는 동안 문제가 발생했습니다.',
  'product_search_dialog.give_feedback': '피드백 보내기',
  'product_search_dialog.google_drive.files_heading': '파일',
  'product_search_dialog.inline_onboarding_action': '확인',
  'product_search_dialog.inline_onboarding_body':
    'Jira 및 Confluence 탭을 사용하여 둘 중 하나에서 최근 항목을 검색하고 볼 수 있습니다.',
  'product_search_dialog.inline_onboarding_title': 'Jira 및 Confluence에서 검색',
  'product_search_dialog.jira.assignee_filters': '담당자로 필터링',
  'product_search_dialog.jira.boards_icon_accessibility_text': '보드 아이콘',
  'product_search_dialog.jira.boards_projects_filters_plans_section_heading': '보드, 프로젝트, 필터 및 계획',
  'product_search_dialog.jira.boards_projects_filters_section_heading': '보드, 프로젝트 및 필터',
  'product_search_dialog.jira.date_filter_30': '30일',
  'product_search_dialog.jira.date_filter_60': '60일',
  'product_search_dialog.jira.date_filter_90': '90일',
  'product_search_dialog.jira.date_filter_any': '모든 기간',
  'product_search_dialog.jira.date_filter_past_30_days': '지난 30일',
  'product_search_dialog.jira.date_filter_past_7_days': '지난 7일',
  'product_search_dialog.jira.date_filter_past_year': '지난해',
  'product_search_dialog.jira.date_filter_today': '오늘',
  'product_search_dialog.jira.date_filter_yesterday': '어제',
  'product_search_dialog.jira.date_filters': '마지막 업데이트',
  'product_search_dialog.jira.empty_prequery.no_results_heading': '작업을 찾으려면 검색을 시작하세요',
  'product_search_dialog.jira.issue_filter_done': '완료',
  'product_search_dialog.jira.issue_filter_open': '미해결',
  'product_search_dialog.jira.issue_filters': '상태로 필터링',
  'product_search_dialog.jira.issue_labels_filters': '레이블로 필터링',
  'product_search_dialog.jira.issue_labels_filters_options_group_label': '모든 레이블',
  'product_search_dialog.jira.issue_labels_filters_placeholder': '레이블 선택',
  'product_search_dialog.jira.issues_section_heading': '이슈',
  'product_search_dialog.jira.issues_section_heading-issue-term-refresh': '업무 항목',
  'product_search_dialog.jira.jira_view_all_issues_new': '모든 이슈 보기',
  'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': '모든 업무 항목 보기',
  'product_search_dialog.jira.project_filters': '프로젝트로 필터링',
  'product_search_dialog.jira.project_filters_find_more': '프로젝트 찾기',
  'product_search_dialog.jira.projects_filters_section_heading': '프로젝트 및 필터',
  'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading':
    '최근 보드, 프로젝트, 필터 및 계획',
  'product_search_dialog.jira.recent_boards_projects_filters_section_heading': '최근 보드, 프로젝트 및 필터',
  'product_search_dialog.jira.recent_projects_filters_section_heading': '최근 프로젝트 및 필터',
  'product_search_dialog.jira.recently_viewed_issues_section_heading': '최근에 본 이슈',
  'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': '최근에 본 업무 항목',
  'product_search_dialog.jira.report_by_filters': '보고자로 필터링',
  'product_search_dialog.jira.reported_by_me_filter': '내가 보고',
  'product_search_dialog.jira.site_filters_find_more': '사이트 찾기',
  'product_search_dialog.loading_filters': '로드 중',
  'product_search_dialog.more_filters': '모든 필터 보기',
  'product_search_dialog.multi_site_advanced_search_label': '다음에서 검색:',
  'product_search_dialog.multi_site_advanced_search_more_dropdown': '이외 {count}개',
  'product_search_dialog.no_options_filters': '옵션 없음',
  'product_search_dialog.opsgenie.advanced_search': '고급 알림 검색',
  'product_search_dialog.opsgenie.alert_heading': '알림',
  'product_search_dialog.opsgenie.expanded.input-placeholder': 'Opsgenie 검색',
  'product_search_dialog.opsgenie.opsgenie_recent_alerts': '최근 알림',
  'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Atlassian Intelligence에 물어보기',
  'product_search_dialog.quick_find_confluence_space': 'Confluence 스페이스',
  'product_search_dialog.quick_find_footer_full_page_search_products_link': '제품 전체에서 검색',
  'product_search_dialog.quick_find_footer_help_text': '검색 개선에 도움을 주세요',
  'product_search_dialog.quick_find_no_content_body_rovo':
    'Atlassian 및 통합 제품에서 원하는 것을 검색하거나 Rovo에게 물어보세요',
  'product_search_dialog.quick_find_no_content_header': '필요한 사항을 검색하세요',
  'product_search_dialog.quick_find_post_query_no_results_body':
    '<SearchContentLink>조직 전반의 모든 콘텐츠를 검색</SearchContentLink>하거나 다른 용어로 다시 검색해 보세요.',
  'product_search_dialog.quick_find_post_query_no_results_header': '해당 제목의 결과를 찾을 수 없습니다',
  'product_search_dialog.quick_find_recent_draft_label': '초안',
  'product_search_dialog.quick_find_recent_search': '최근 검색',
  'product_search_dialog.quick_find_recent_search_text_dialog': '최근 검색 기반',
  'product_search_dialog.quick_find_recent_spaces_additional_meta': '최근에 방문',
  'product_search_dialog.quick_find_recently_viewed': '최근에 본 항목',
  'product_search_dialog.quick_find_result_item_team': '팀',
  'product_search_dialog.quick_find_results_section': '검색 결과',
  'product_search_dialog.quick_find_rovo_tip': '"휴가 정책이 무엇입니까?"와 같은 질문을 입력하면 Rovo가 답을 찾습니다.',
  'product_search_dialog.quick_find_search_input_rovo_placeholder': '검색하거나 Rovo에게 질문하기',
  'product_search_dialog.quick_find_search_results': '검색 결과',
  'product_search_dialog.quick_find_show_filtered_confluence_results': 'Confluence 스페이스, 기여자 등으로 필터링',
  'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon':
    '{confluenceIcon} Confluence 스페이스, 기여자 등으로 필터링',
  'product_search_dialog.quick_find_show_organization_results': '조직 검색',
  'product_search_dialog.recent_spaces_section_heading': '최근 스페이스',
  'product_search_dialog.recently_viewed_heading': '고급 검색',
  'product_search_dialog.recently_viewed_section_heading': '최근에 조회',
  'product_search_dialog.recently_worked_with_section_heading': '최근에 공동 작업',
  'product_search_dialog.results.remove_button_label': '이 항목을 제거합니다.',
  'product_search_dialog.search_input_collapsed_placeholder': '검색',
  'product_search_dialog.search_input_enlarged_aria_label': '고급 검색으로 이동하려면 Enter를 누르세요',
  'product_search_dialog.search_people_link': '사용자 검색',
  'product_search_dialog.show_all_results_link': '모든 결과 보기',
  'product_search_dialog.show_more_results_link': '더 보기',
  'product_search_dialog.townsquare.search_input_expanded_placeholder': '홈 검색',
  'product_search_dialog.townsquare_goals_heading': '목표',
  'product_search_dialog.townsquare_goals_view_all': '모든 목표 검색',
  'product_search_dialog.townsquare_help_links_heading': '도움말 링크',
  'product_search_dialog.townsquare_learnings_risks_decisions_heading': '배운 점, 위험 및 결정',
  'product_search_dialog.townsquare_people_heading': '사용자',
  'product_search_dialog.townsquare_people_view_all': '모든 사용자 검색',
  'product_search_dialog.townsquare_projects_heading': '프로젝트',
  'product_search_dialog.townsquare_projects_view_all': '모든 프로젝트 검색',
  'product_search_dialog.townsquare_recent_people': '최근 사용자',
  'product_search_dialog.townsquare_recent_topics': '최근 토픽',
  'product_search_dialog.townsquare_teams_heading': '팀',
  'product_search_dialog.townsquare_teams_view_all': '모든 팀 검색',
  'product_search_dialog.townsquare_topics_heading': '토픽',
  'product_search_dialog.townsquare_topics_view_all': '모든 토픽 검색',
  'product_search_dialog.trello.archived': '보관됨',
  'product_search_dialog.trello.archived.card-hover': '보관된 카드입니다',
  'product_search_dialog.trello.board': '보드',
  'product_search_dialog.trello.boards_heading': '보드',
  'product_search_dialog.trello.cards_heading': '카드',
  'product_search_dialog.trello.closed': '종료됨',
  'product_search_dialog.trello.closed.board-hover': '닫힌 보드입니다',
  'product_search_dialog.trello.expanded.input-placeholder': 'Trello 검색',
  'product_search_dialog.trello.feedback_link': '검색 결과를 개선하는 데 도움을 주세요.',
  'product_search_dialog.trello.list': '목록',
  'product_search_dialog.trello.private_workspace': '비공개 작업 영역',
  'product_search_dialog.trello.recent_boards_heading': '최근 보드',
  'product_search_dialog.trello.workspace': '작업 영역',
  'product_search_dialog.updated_date_formatter': '{date}에 업데이트',
  'search_dialog.filters.group.show-more': '더 보기',
  'search_dialog.search_input_clear_label': '검색 세션 지우기',
  'search_dialog.search_input_exit_label': '검색 종료',
};
